module.exports = __webpack_public_path__ + "static/media/medical_05.27698473.jpg";